<template>
<div class="user_order no-trans" v-loading="loading">
    <div class="order_titles">我的消息</div>
    <div class="user_order_box">
        <div class="order_types">
            <div class="lefts">
                <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" @click="handle_type(item)">
                    {{ item.title }}
                </div>
            </div>
            <div class="rights">
                <el-input
                    placeholder="输入关键字搜索"
                    v-model="keyword">
                    <div slot="suffix" class="" @click="handle_seach">
                        <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                    </div>
                </el-input>
            </div>
        </div>
        <div class="order_0" v-if="lists.length==0">
            <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
            <div class="texts">暂无信息 </div>
        </div>
        <div class="lists" v-if="lists.length!=0">
            <div class="list_item" v-for="(item,index) in lists" :key="index" @click="handle_see(item)">
                <div class="item_tops">
                    <div class="item_title">
                        {{item.title}}
                        <div class="borders" v-if="item.if_read==0"></div>
                    </div>
                    <div class="item_times">{{ item.created_at1 }}</div>
                </div>
                <div class="item_boms">
                    {{ item.desc }}
                </div>
            </div>
        </div>
        <div class="pages_box">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.page"
                background
                :page-size="pages.limit"
                layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns"  @click="handle_pages(last_page)">尾页</div>
        </div>
    </div>
    
</div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:0,
            type_list:[
                {
                    title:'全部消息',
                    state:0,
                },
                {
                    title:'系统消息',
                    state:1,
                },
                {
                    title:'活动消息',
                    state:2,
                },
                {
                    title:'服务通知',
                    state:3,
                },
                {
                    title:'审核通知',
                    state:4,
                }
            ],
            lists:[],
            last_page:0,
            total:100,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state
            this.pages.page=1
            this.get_list()
            
        },
        handle_seach(){
            console.log('点击搜索')
            this.pages.page=1
            this.get_list()
        },
        handleSizeChange(e){
            console.log('条数',e)   
            this.pages.limit=e
            this.get_list()         
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        handle_deitial(){
            this.$router.push({
                path:'/user_wt/user_wt_detial',
                query:{

                }
            })
        },
        handle_see(item){
            this.loading=true
            this.$api("systemNoticeDetail", {
                id:item.id
			}, "get").then((res) => {
                this.loading = false
                console.log('消息列表',res)
                if (res.code == 1) {
                    this.get_list()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list(){
            this.loading=true
            this.$api("systemNoticeList", {
                ...this.pages,
                type:this.types_ac,
			}, "get").then((res) => {
                this.loading = false
                console.log('消息列表',res)
                if (res.code == 1) {
                    this.lists=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },



    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                /deep/.el-input{
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 282px;
                        height: 32px;
                    }
                    .el-input__suffix{
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                    }
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .lists{
            padding-top: 23px;
            .list_item{
                padding-bottom: 24px;
                border-bottom: 1px solid #E5E5E5;
                margin-bottom: 20px;
                .item_tops{
                    display: flex;
                    align-items: end;
                    
                    .item_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        display: flex;
                        // align-items: center;

                        .borders{
                            width: 7px;
                            height: 7px;
                            background-color: red;
                            border-radius: 50%;
                            margin-left: 5px;
                            margin-top: 2px;
                        }

                    }
                    .item_times{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #BFC4CD;
                        margin-left: 44px;
                    }
                }
                .item_boms{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #666666;
                    padding-top: 10px;
                }
            }
            
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_order.no-trans .user_order_box {
        padding: 16px 16px;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_order.no-trans .user_order_box .order_types {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types {
        font-size: 14px;
        padding-bottom: 12px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types_ac {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__inner {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 3px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix img {
        width: 18px;
    }
    .user_order.no-trans .user_order_box .order_0 {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_0 img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_0 .texts {
        padding-top: 16px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .lists {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .lists .list_item {
        padding-bottom: 16px;
        margin-bottom: 16px;
    }
    .user_order.no-trans .user_order_box .lists .list_item .item_tops {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .lists .list_item .item_tops .item_title {
        font-size: 18px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .lists .list_item .item_tops .item_title .borders {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        margin-left: 5px;
        margin-top: 2px;
    }
    .user_order.no-trans .user_order_box .lists .list_item .item_tops .item_times {
        font-size: 14px;
        margin-left: 16px;
    }
    .user_order.no-trans .user_order_box .lists .list_item .item_boms {
        font-size: 16px;
        padding-top: 10px;
    }
    .user_order.no-trans .user_order_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
